// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from '../supports/dms-common';
import MemberListTable from './MemberListTable';
import GroupListTable from './GroupListTable';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import PrintIcon from '@mui/icons-material/Print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

function SelMemberDialog(props) {

  const { open, disableUserTab, disableGroupTab, disableMultiSelectMember, onClose, members, groups, onSelect } = props;

  const initialTabNum = disableUserTab ? '2' : '1';

  const [tabNum, setTabNum] = useState(initialTabNum);
  const handleTabChange = (event, newValue) => {
    setTabNum(newValue);
  };

  // useEffect(() => {
  //   console.log("useEffect SelMemberDialog(did mounted)")

  // }, [])

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const [selUsers, setSelUsers] = useState([]);
  const handleSelectUserChange = (aUsers) => {
    setSelUsers(aUsers);
  }

  const [selGroups, setSelGroups] = useState([]);
  const handleSelectGroupChange = (aGroups) => {
    // console.log("onSelectGroupChange", aGroups);
    setSelGroups(aGroups);
  }

  const handleSelectConfirmClick = () => {
    onSelect && onSelect(selUsers, selGroups);

    setSelUsers([]);
    setSelGroups([]);
  }

  return (

    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      open={open}
      aria-describedby="dialog-sel-member"

      scroll="paper"
      PaperProps={{
        sx: {
          display: 'flex',
          minHeight: "80vh",
          maxHeight: "80vh",
        }
      }}
    >
      {/* <DialogTitle>Select User/Group</DialogTitle> */}
      <DialogContent>
        <Box sx={{
          width: '100%',
          bgcolor: 'background.paper',
        }}>
          <TabContext value={tabNum}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                {!disableUserTab &&
                  <Tab label="Users" value="1" />
                }
                {!disableGroupTab &&
                  <Tab label="Groups" value="2" />
                }
              </TabList>
            </Box>


            <TabPanel value="1" sx={{ p: 1 }} >
              <Box sx={{ display: 'flex', height: "50vh" }} >
                <MemberListTable members={members} selUsers={selUsers} onSelectUserChange={handleSelectUserChange} disableMultiSelectMember={disableMultiSelectMember} />
              </Box>


            </TabPanel>
            <TabPanel value="2" sx={{ p: 1 }} >
              <Box sx={{ display: 'flex', height: "50vh" }} >
                <GroupListTable groups={groups} selGroups={selGroups} onSelectGroupChange={handleSelectGroupChange} />
              </Box>

            </TabPanel>
          </TabContext>

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button type="submit" variant="contained" onClick={handleSelectConfirmClick}>Select</Button>
      </DialogActions>
    </Dialog>

  );
}

SelMemberDialog.propTypes = {
  open: PropTypes.bool,
  disableUserTab: PropTypes.bool,
  disableGroupTab: PropTypes.bool,
  disableMultiSelectMember: PropTypes.bool,
  onClose: PropTypes.func,
  members: PropTypes.array,
  groups: PropTypes.array,
  onSelect: PropTypes.func,
};

export default SelMemberDialog